module.exports = __webpack_public_path__ + "static/media/00_andinvainthedreamer.a759170d.jpg";